import React from 'react';
import EmptyState from '../components/EmptyState';

const DevProgramsOpsPage = () => {
  return (
    <div className="flex flex-col gap-6 p-6">
      <header>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50">
          Programs & Operations
        </h1>
        <p className="text-sm text-slate-500">Programs, sessions, coaching, and tasks</p>
      </header>
      <EmptyState message="Programs & Operations page - Coming soon" />
    </div>
  );
};

export default DevProgramsOpsPage;
